import {getTranslationByKey} from "@/stores/translation";

export function MailtoMessage(url: string) {
    const protocol = "mailto:";
    const subject = getTranslationByKey('Teilen - Email Betreff Haus');
    const body = getTranslationByKey('Teilen - Email Text Haus').replace('%URL%', url).replace('%HAUSFINDER%', location.origin + "/hausfinder");

    return `${protocol}?subject=${subject}&body=${body}`;
}